import Link from 'next/link';
import { useState } from 'react';
import { sendMondayApi } from '@apps/utils/monday';
import { toast } from 'react-toastify';

const ContactForm = () => {
  const INITIAL_STATE = {
		name: "",
		email: "",
		message: "",
	};
  const [contact, setContact] = useState(INITIAL_STATE);

  const handleChange = async (e) => {
		const { name, value } = e.target;
		setContact((prevState) => ({ ...prevState, [name]: value }));
	};

  const handleSubmit = async(e) => {
    e.preventDefault();
    const { name, email, message } = contact;

    // Get the form data
    const formData = {
      name: name ?? '',
      email: { 'email': email ?? '', 'text': email ?? '' },
      message: message ?? ''
    };
    await sendMondayApi(formData).then((result) => {
      if (result && result?.status == 200) {
        if(result?.data?.error_code) {
          toast.error('Invalid, please try again later.');
          console.log({ 'Monday res - err': result?.data });
        } else {
          toast.success('Successfully Submit!');
          resetForm();
        }
      } else {
        toast.error('Invalid, please try again later.');
      }
    });
  };

  const resetForm = () => {
		setContact(INITIAL_STATE);
	}

  return (
    <form id='contact-form' method='post' onSubmit={handleSubmit}>
      <div className='flex space-x-7'>
        <div className='mb-6 w-1/2'>
          <label className='font-display text-jacarta-700 mb-1 block text-sm dark:text-white'>
            Name<span className='text-red'>*</span>
          </label>
          <input
            name='name'
            className='contact-form-input dark:bg-[#09092C] border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white'
            id='name'
            type='text'
            placeholder="Name"
            value={contact.name}
            onChange={handleChange}

            required
          />
        </div>

        <div className='mb-6 w-1/2'>
          <label className='font-display text-jacarta-700 mb-1 block text-sm dark:text-white'>
            Email<span className='text-red'>*</span>
          </label>
          <input
            name='email'
            className='contact-form-input dark:bg-[#09092C] border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white'
            id='email'
            type='email'
            placeholder="Email"
            value={contact.email}
            onChange={handleChange}
            required
          />
        </div>
      </div>

      <div className='mb-4'>
        <label className='font-display text-jacarta-700 mb-1 block text-sm dark:text-white'>
          Message<span className='text-red'>*</span>
        </label>
        <textarea
          id='message'
          className='contact-form-input dark:bg-[#09092C] border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white'
          required
          name='message'
          placeholder="Write your message..."
          value={contact.message}
          onChange={handleChange}
          rows='5'
        />
      </div>

      <div className='mb-6 flex items-center space-x-2'>
        <input
          type='checkbox'
          id='contact-form-consent-input'
          name='agree-to-terms'
          className='checked:bg-primary dark:bg-jacarta-600 text-primary border-jacarta-200 focus:ring-accent/20 dark:border-jacarta-500 h-5 w-5 self-start rounded focus:ring-offset-0 cursor-pointer'
          required
        />
        <label className='dark:text-jacarta-200 text-sm'>
          I agree to the{' '}
          <Link href='/terms-and-conditions' legacyBehavior>
            <a className='text-primary'>Terms of Service</a>
          </Link>
        </label>
      </div>

      <button
        type='submit'
        className='bg-primary hover:bg-accent-dark rounded-full py-3 px-8 text-center font-semibold text-white transition-all'
        id='contact-form-submit'
      >
        Submit
      </button>
    </form>
  );
};

export default ContactForm;
